// extracted by mini-css-extract-plugin
export default {"successAnimation":"LoginSuccessAnimation_successAnimation__loh5v","fadeIn":"LoginSuccessAnimation_fadeIn__5dQDh"};